import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-mqtt-api',
    templateUrl: './mqtt-api.component.html',
    standalone: false
})
export class MqttApiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
